<template>
    <div v-if="supplierName" class="supplier-name font-weight-regular text-medium-emphasis">
        {{ supplierName }}
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class SupplierNameLabel extends Vue {
        @Prop({required: false, type: String}) supplierName
    }

    export default SupplierNameLabel
</script>
